import {
  Alert,
  Flex,
  Heading,
  IconAnnotateLine,
  IconButton,
  Spinner,
  Text,
  Tooltip,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";

export const AiStatementButton = ({ handler, loading }) => {
  const { t } = useTranslation();

  return (
    <Tooltip
      renderTip={t("analyze.generate.tooltipGenerate")}
      placement="top"
      on={["click", "hover", "focus"]}
      color="primary-inverse"
    >
      <IconButton
        onClick={handler}
        renderIcon={
          loading ? (
            <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
          ) : (
            IconAnnotateLine
          )
        }
        screenReaderLabel={t("analyze.generate.tooltipGenerate")}
        size="small"
        interaction={loading ? "disabled" : "enabled"}
      />
    </Tooltip>
  );
};

export const AiStatement = ({ statement }) => {
  const { t } = useTranslation();

  return (
    <Alert variant={statement.outcome ? "info" : "warning"}>
      {statement.outcome ? (
        <Flex justifyItems="space-between">
          <Flex.Item shouldShrink>
            <Heading as="h5" level="h4">
              <Text size="small">
                {t("analyze.generate.suggestedGeneratedOutcome")}:
              </Text>
            </Heading>
            <Text size="small">{statement.outcome}</Text>
            <Heading as="h5" level="h4" margin="small 0 0 0">
              <Text size="small">
                {t("analyze.generate.explanationOutput")}:
              </Text>
            </Heading>
            <Text size="x-small">{statement.explanation}</Text>
          </Flex.Item>
          {/* Remove button until functionality is needed */}
          {/* <Flex.Item>
            <IconButton
              size="small"
              screenReaderLabel={t("analyze.generate.acceptSuggestedOutcome")}
              renderIcon={IconImportLine}
            />
          </Flex.Item> */}
        </Flex>
      ) : (
        <Flex justifyItems="space-between">
          <Flex.Item>
            <Heading as="h5" level="h4">
              {t("analyze.generate.noSuggestedOutcomeHeader")}
            </Heading>
            <Text size="small">
              {t("analyze.generate.noSuggestedOutcomeText")}
            </Text>
          </Flex.Item>
        </Flex>
      )}
    </Alert>
  );
};
